<template lang="pug">
  CoverSection.CollectionCover
    .CoverSection_background(ref="background")
      .CoverSection_background_asset
        AdaptativeImg(:derivatives="backgroundImg" :type="'cover'" :fit="true" :name="title")

    .CoverSection_background_cache(ref="backgroundcache")

    PageTitle(:top="$tc('collection.collection')", :title="title", :bottom="type")

    .CollectionCover_footer
      ButtonSimple(class="ButtonSimple-with-background" @click.native="scrollToDrawers") {{ $tc('collection.drawers_discover', numOfDrawers, { count: numOfDrawers }) }}

</template>

<script>

import ButtonSimple from '@/components/common/ButtonSimple'
import AdaptativeImg from '@/components/common/AdaptativeImg'
import PageTitle from '@/components/common/PageTitle'
import BackgroundRelief from '@/components/common/BackgroundRelief'
import CoverSection from '@/components/common/CoverSection'

export default {
  props: ['title', 'type', 'numOfDrawers', 'backgroundImg'],
  components: { ButtonSimple, PageTitle, BackgroundRelief, CoverSection, AdaptativeImg },
  data () {
    return {}
  },
  mounted () {
    this.$parallax.set(this.$refs.backgroundcache, { opacity: 0 }, { opacity: 0 }, { opacity: 1 }, null, -0.3)
    this.catchElement()
  },
  beforeDestroy () {
    this.$parallax.remove(this.$refs.backgroundcache)
  },
  methods: {
    scrollToDrawers () {
      this.$scroll.to('.CollectionDrawerList')
    },
    captureMousePosition (event) {
      this.rect = this.$refs.background.getBoundingClientRect()
      this.x = Math.floor((event.clientX - (this.rect.left + (this.rect.width / 2))) / 70)
      this.y = Math.floor((event.clientY - (this.rect.top + (this.rect.height / 2))) / 70)

      // TweenMax.to(this.$refs.background, 2, { x: this.x, y: this.y, ease: Quint.easeOut })
    },
    catchElement () {
      if (!!('ontouchstart' in window) || !!('onmsgesturechange' in window)) return

      this.$refs.backgroundcache.addEventListener('mousemove', this.captureMousePosition)
    },
    detachElement () {
      this.$refs.backgroundcache.removeEventListener('mousemove', this.captureMousePosition)

      // TweenMax.to(this.$refs.background, 1, { x: 0, y: 0, ease: Quint.easeOut })
    }
  }
}

</script>

<style lang="stylus" scoped>
.CollectionCover

  z-index 2

  .CoverSection_background

    opacity 0.25

  &_footer
    width 100%
    height 150px
    // background-color $grey-2
    display flex
    flex-direction row
    align-items center

  .PageTitle
    flex-grow 1

</style>
